<template>
  <b-row>
    <div id="loadingmessage"
      style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
      v-if="loading">
      <p style="position: absolute; color: White; top: 40%; left: 50%;">
        <img src="../../assets/loader.gif" />
      </p>
    </div>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <div slot="header" v-html="caption"></div>
          <div v-if="data.length > 0">
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed"
              responsive="sm" :items="data" :fields="fields" :current-page="currentPage" :per-page="perPage"
              @row-clicked="rowClicked" class="table-responsive cnt">

              <template slot="image" slot-scope="item" style="text-align:center;">
                <img v-if="item.item.image != null" v-bind:src="imageURL + item.item.image" width="50px"
                  height="50px" />
                <p v-else>No Image</p>
              </template>
              <template slot="_id" slot-scope="data">
                <span style="padding-left:20px!important;">
                  <router-link :to="'/sightingsloc1/' + data.item._id">
                    <b-button variant="dark"><i class="fa fa-map-marker"></i></b-button>
                  </router-link>
                </span>
                <span style="padding-left:20px!important;">
                  <router-link :to="'/sightingsview/' + data.item._id">
                    <b-button variant="success"><i class="fa fa-eye"></i></b-button>
                  </router-link>
                </span>
                <span style="padding-left:20px!important;padding-bottom:20px!important;">
                  <router-link :to="'/editsightings/' + data.item._id">
                    <button class="btn btn-info text-white" variant="light"><i class="fa fa-edit"></i></button>
                  </router-link>
                </span>

                <span style="padding-left:20px!important;">
                  <b-button variant="danger" @click="delrep(data.item._id)"><i class="fa fa-trash"></i></b-button>
                </span>

              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" :total-rows="getRowCount(data)" :per-page="perPage" v-model="currentPage"
                prev-text="Prev" next-text="Next" hide-goto-end-buttons />
            </nav>
          </div>
          <div v-else>
            <p>No List Found</p>
          </div>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  name: "Users",
  props: {
    caption: {
      type: String,
      default: "Observations"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      type: localStorage.getItem("type"),
      errors: [],
      data: [],
      fields: [
        {
          key: "index",
          label: "Sl No.",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt"
        },
        {

          key: "userid.name",
          label: "Observer",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt"
        },
        {
          key: 'turtle.name',
          label: 'Turtle Name',
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt reptur"
        },
        {
          key: 'image',
          label: 'Turtle Image',
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt-"
        },
        {
          key: "type",
          label: "Type",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt"
        },
        // {
        //   key: "purpose",
        //   label: "Purpose",
        //   sortable: false,
        //   thClass: " cnt",
        //   tdClass: "cnt"
        // },
        {
          key: "state",
          label: "State",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt "
        },

        {
          key: "condition",
          label: "Condition",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt "
        },
        {
          key: "lifestage",
          label: "Life Stage",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt "
        },
        {
          key: "createddate",
          label: "Observed on",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt ",
        },
        {
          label: " Action",
          key: "_id",
          sortable: false,
          thClass: "cnt",
          tdClass: "cnt obsact"
        }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      loading: false
    };
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    delrep(val) {
      this.loading = true;
      if (confirm("Are you sure?")) {
        this.loading = true;
        var data1 = {};
        data1["id"] = val;
        data1["x-auth-token"] = localStorage.getItem("token");
        axios({
          method: "POST",
          data: data1,
          url: "/report/remove/"
        })
          .then(response => {
            this.loading = false;
            if (response.data.status) {
              this.getList();
              this.msg = response.data.msg;
            } else {
              this.loading = false;
              this.$router.push({ name: "reportlist" });

            }
          })
          .catch(err => {
            this.loading = false;
            this.errors.push(err);
            this.$router.push({ name: "reportlist" });

          });
      }
      else {
        this.loading = false;
        this.$router.push({ name: "reportlist" });
      }
    },
    getList() {
      this.loading = true;
      var data1 = {}
      data1["purpose"] = "rescue"
      data1["x-auth-token"] = localStorage.getItem("token")
      axios({
        method: "GET",
        url: "report/getlist",
        data: data1,
        params: { 'purpose': "observation", 'token': localStorage.getItem("token") },
      })
        .then(response => {
          this.loading = false;

          if (response.data.status === true) {
            this.data = response.data.data;
            var temp = [];
            for (var i = 0; i < this.data.length; i++) {
              var dt = this.data[i].createddate.slice(0, 10);
              this.data[i].createddate = dt;
              this.data[i].index = i + 1

            }
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch(e => {
          this.loading = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },

    getBadge(status) {
      return status === "sucess"
        ? "success"
        : status === "initiate"
          ? "secondary"
          : status === "progress"
            ? "warning"
            : status === "failure"
              ? "danger"
              : "primary";
    },
    getRowCount(data) {
      return data.length;
    },
    // userLink(id) {
    //   return `users/${id.toString()}`;
    // },
    // rowClicked(data) {
    //   const userLink = this.userLink(data._id);
    //   this.$router.push({ path: userLink });
    // }
  }
};
</script>

<style>
.card-body>>>table>tbody>tr>td {
  cursor: pointer;
}

.cnt {
  text-align: center !important;
}

.obs {
  width: 30% !important;

}

.obsact {
  min-width: 300px !important;
}

.reptur {
  width: 150px !important;
}
</style>
